import { formatDate } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelList, DetailLabelValuePair } from '@strata/react-label-value-pairs';

import { NoAuthorizationNeededMessage } from 'components/shared/NoAuthorizationNeededMessage';
import { formatAuths } from 'services/referralHelpers';
import { type ReferralDetails as ReferralDetailsInterface } from 'store/api/treatmentApi';
import { type LiveReferral } from 'store/liveReferrals/liveReferralsHooks';

interface ReferralDetailsProps {
    selectedReferral?: LiveReferral;
    referralDetails?: ReferralDetailsInterface;
}

export const ReferralDetails = ({
    selectedReferral = undefined,
    referralDetails = undefined,
}: ReferralDetailsProps) => (
    <FormSectionWithRows
        sectionTitle="Referral Details"
        isLoading={!(selectedReferral && referralDetails)}
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Outreach Start Date"
                    value={formatDate(referralDetails?.outreachDate)}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Servicing Start Date"
                    value={formatDate(referralDetails?.referralStart)}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Referral Expiration"
                    value={formatDate(selectedReferral?.referralExpiration)}
                />
                <DetailLabelList
                    label="Authorization Period(s)"
                    values={
                        (referralDetails?.auths ?? []).length > 0
                            ? formatAuths(referralDetails!.auths)
                            : [<NoAuthorizationNeededMessage key="no-authorization-needed" />]
                    }
                />
            </>
        }
    />
);
